<template>
  <div class="upload-cover-wrap">
    <div class="image"
         v-if="cover"
         :style="{width: `${img_height*autoSize}px`,height: `${img_height}px`}">
      <img :src="cover"
           alt />
      <div class="img-shadow">
        <!--<i class="el-icon-zoom-in deal-item" title="预览" @click="preview()"></i>-->
        <i class="el-icon-crop deal-item"
           title="裁剪"
           @click="crop()"></i>
        <i class="el-icon-delete deal-item"
           title="删除"
           @click="delImg()"></i>
      </div>
      <!-- <div class="empty-img" v-if="typeof cover == 'string'" v-loading="uploadLoading">
        <i class="el-icon-picture"></i>
      </div>-->
    </div>
    <div class="upload-btn-wrap"
         v-if="!cover">
      <el-upload action="/admin/upload/image"
                 :show-file-list="false"
                 name="imageFile"
                 :on-success="uploadSuccess"
                 :on-error="uploadError">
        <div class="cover-box"
             :style="{width: `${img_height*autoSize}px`,height: `${img_height}px`}">
          <div class="add-btn"><i class="el-icon-circle-plus-outline add"></i></div>
          <div class="title">{{tips}}</div>
        </div>
      </el-upload>
    </div>
    <my-cropper :isShow.sync="showCropper"
                :ratio="ratio"
                :cropperData="cropperData"
                @updateImg="cropUpdateImg"></my-cropper>
  </div>
</template>

<script>
import myCropper from "./my-cropper.vue";

export default {
  props: {
    autoSize: {
      type: Number,
      default: 1
    },
    img_width: {
      default: "160"
    },
    img_height: {
      default: "160"
    },
    tips: {
      default: "图片比例为16：9，JPG、PNG格式"
    },
    coverImg: {
      type: String,
      default: ""
    }
  },
  watch: {
    coverImg (val) {
      this.cover = val;
    }
  },
  computed: {
    ratio () {
      return this.img_height / this.img_height * this.autoSize;
    }
  },
  data () {
    return {
      cover: "",
      uploadLoading: false,
      showCropper: false,
      cropperData: {
        url: require("../assets/logo.png")
      }
    };
  },
  methods: {
    uploadSuccess (response, file, fileList) {
      // console.log(response);
      this.cover = response.result.url;
      this.cropperData.url = response.result.url;
      this.$emit("uploadSuccess", response.result.url);
    },
    uploadError () {
      this.$message.error("上传失败");
    },
    preview () { },
    crop () {
      this.showCropper = true;
    },
    delImg () {
      this.cover = "";
      this.$emit("uploadSuccess", this.cover);
    },
    cropUpdateImg (data) {
      // console.log(data);
      //剪切后的图像返回给父组件
      this.cover = data.url;
      this.$emit("uploadSuccess", data.url);
    }
  },
  components: {
    myCropper
  }
};
</script>

<style lang="less" scoped>
.upload-cover-wrap {
  .image {
    overflow: hidden;
    position: relative;
    &:hover {
      .img-shadow {
        display: flex;
      }
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}

.empty-img {
  width: 100%;
  height: 100%;
  font-size: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
}

.img-shadow {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: none;
  justify-content: center;
  align-items: center;
}

.deal-item {
  color: #ffffff;
  font-size: 16px;
  cursor: pointer;
  &:hover {
    color: #369ad1;
  }
  & + .deal-item {
    margin-left: 20px;
  }
}

.upload-btn-wrap {
  .cover-box {
    padding-top: 5px;
    border: 1px dashed #dcdfe6;
    color: #999999;
    overflow: hidden;
    .add {
      font-size: 26px;
    }
    &:hover {
      color: #369ad1;
      border-color: #369ad1;
    }
    .add-btn {
      line-height: 26px;
      height: 26px;
    }
    .title {
      width: 100%;
      line-height: 14px;
      transform: scale(0.8);
      text-align: left;
      word-break: break-all;
    }
  }
}
</style>
